/* src/app/layouts/single/single.component.css */
/*# sourceMappingURL=single.component.css.map */
